/**
 * @generated SignedSource<<cc3bb4b3c6817e3c2530775cd0fafbdc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditFreeTextSelfCheckElementInput = {
  clientMutationId?: string | null;
  freeTextSelfCheckElementId: string;
  newEnableSolutionReveal: boolean;
  newSolutionText?: string | null;
  newText: string;
  newTitle: string;
};
export type freeTextSelfCheckElementForm_EditFreeTextSelfCheckElementMutation$variables = {
  input: EditFreeTextSelfCheckElementInput;
};
export type freeTextSelfCheckElementForm_EditFreeTextSelfCheckElementMutation$data = {
  readonly Admin: {
    readonly ElearningV2: {
      readonly editFreeTextSelfCheckElement: {
        readonly freeTextSelfCheckElement: {
          readonly " $fragmentSpreads": FragmentRefs<"freeTextSelfCheckElementForm_FreeTextSelfCheckElementFragment">;
        };
      } | null;
    };
  };
};
export type freeTextSelfCheckElementForm_EditFreeTextSelfCheckElementMutation = {
  response: freeTextSelfCheckElementForm_EditFreeTextSelfCheckElementMutation$data;
  variables: freeTextSelfCheckElementForm_EditFreeTextSelfCheckElementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "freeTextSelfCheckElementForm_EditFreeTextSelfCheckElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElearningV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "ElearningV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditFreeTextSelfCheckElementPayload",
                "kind": "LinkedField",
                "name": "editFreeTextSelfCheckElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FreeTextSelfCheckElement",
                    "kind": "LinkedField",
                    "name": "freeTextSelfCheckElement",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "freeTextSelfCheckElementForm_FreeTextSelfCheckElementFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "freeTextSelfCheckElementForm_EditFreeTextSelfCheckElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElearningV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "ElearningV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditFreeTextSelfCheckElementPayload",
                "kind": "LinkedField",
                "name": "editFreeTextSelfCheckElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FreeTextSelfCheckElement",
                    "kind": "LinkedField",
                    "name": "freeTextSelfCheckElement",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enableSolutionReveal",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "solutionText",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "351577cdb78961a99e20adfd220682c3",
    "id": null,
    "metadata": {},
    "name": "freeTextSelfCheckElementForm_EditFreeTextSelfCheckElementMutation",
    "operationKind": "mutation",
    "text": "mutation freeTextSelfCheckElementForm_EditFreeTextSelfCheckElementMutation(\n  $input: EditFreeTextSelfCheckElementInput!\n) {\n  Admin {\n    ElearningV2 {\n      editFreeTextSelfCheckElement(input: $input) {\n        freeTextSelfCheckElement {\n          ...freeTextSelfCheckElementForm_FreeTextSelfCheckElementFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment freeTextSelfCheckElementForm_FreeTextSelfCheckElementFragment on FreeTextSelfCheckElement {\n  id\n  title\n  text\n  enableSolutionReveal\n  solutionText\n}\n"
  }
};
})();

(node as any).hash = "4eccf7103a51686d069d2239033ce5c6";

export default node;
